var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78 78",
    width: 78,
    height: 78,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wishlist-svgrepo-com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #c39d63;stroke: #c39d63;stroke-width: 3 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.1 32c-1.4-7.7 3.7-14.4 11.6-15 7-0.6 10.5 7.9 11.2 9.6q0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0c3.3-9 9.2-9.3 11.3-9.5 5.6-0.7 13.1 3.7 11.6 13.8-2.2 14-23.1 29.8-23.1 29.8 0 0-20.1-13.7-22.8-28.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistFull);
export default __webpack_public_path__ + "static/media/wishlist_full.2ac707e96eca57ed3155124f485ba4c8.svg";
export { ForwardRef as ReactComponent };